'use strict';

(function () {
	angular.module('onboarding.common').directive('inAppMessage', [
		'InAppMessagingService',
		function (inAppMessagingService) {
			return {
				restrict: 'E',
				link: link,
				templateUrl: '/app/common/directives/inAppMessaging/inAppMessage.html',
			};

			function link(scope) {
				function getMessage() {
					inAppMessagingService.getMessage().then(function (response) {
						if (response.data) {
							var html = marked.parse(DOMPurify.sanitize(response.data.text));
							html = html.replace(/<a/i, '<a target=\'_blank\'');

							scope.message = {
								title: response.data.title,
								text: html,
							};
						}
					});
				}
				getMessage();
			}
		},
	]);
})();
